import { toast } from "sonner";
import { updateMeeting } from "./api";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "utils/react-query";

function buildPayload(values) {
    const payload = {};
    const { participants, deletedParticipantIds = [], ...rest } = values;

    const readOnlyFields = ['id', 'user_created', 'date_created', 'date_updated'];

    Object.entries(rest).forEach(([key, value]) => {
        if (
            !readOnlyFields.includes(key) &&
            value !== undefined &&
            value !== null &&
            value !== ''
        ) {
            payload[key] = value;
        }
    });

    if (values.starts_at) {
        payload.starts_at = values.starts_at;
    }
    if (values.ends_at) {
        payload.ends_at = values.ends_at;
    }

    // Handle participants: create, update, delete
    if (participants) {
        const participantsToCreate = [];
        const participantsToUpdate = [];

        participants.forEach(p => {
            if (!p.participantId) {
                // New participant (no relationship ID) → CREATE
                participantsToCreate.push({
                    participant: {
                        email: p.email
                    }
                });
            } else {
                // Existing participant → UPDATE
                if (p.email && p.id) {
                    participantsToUpdate.push({
                        participant: {
                            email: p.email,
                            id: p.id
                        },
                        id: p.participantId // relationship ID
                    });
                }
            }
        });

        payload.participants = {
            create: participantsToCreate,
            update: participantsToUpdate,
            delete: deletedParticipantIds || []
        };
    }

    return payload;
}

export function useUpdateMeeting() {
    return useMutation({
        mutationFn: async ({ meetingId, values }) => {
            const payload = buildPayload(values);
            const response = await updateMeeting({ meetingId, item: payload });
            return response;
        },
        onSuccess: () => {
            toast.success("Meeting Updated Successfully");
            queryClient.invalidateQueries();
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
